'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardSignStats(signatures, envelopes) {
  this.DI = 0;
  this.DH = 0;
  this.DI = signatures;
  this.DH = envelopes;
}
export { $c_Lpresto_types$DashboardSignStats as $c_Lpresto_types$DashboardSignStats };
$p = $c_Lpresto_types$DashboardSignStats.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardSignStats;
/** @constructor */
function $h_Lpresto_types$DashboardSignStats() {
}
export { $h_Lpresto_types$DashboardSignStats as $h_Lpresto_types$DashboardSignStats };
$h_Lpresto_types$DashboardSignStats.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardSignStats"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.DI);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.DH);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 2);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$DashboardSignStats) && ((this.DI === x$0.DI) && (this.DH === x$0.DH))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "DashboardSignStats";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.DI;
  }
  if ((n === 1)) {
    return this.DH;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$DashboardSignStats(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jG)));
}
export { $isArrayOf_Lpresto_types$DashboardSignStats as $isArrayOf_Lpresto_types$DashboardSignStats };
var $d_Lpresto_types$DashboardSignStats = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardSignStats, "presto.types$DashboardSignStats", ({
  jG: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardSignStats as $d_Lpresto_types$DashboardSignStats };
//# sourceMappingURL=presto.types$-Dashboard-Sign-Stats.js.map
